import { toNestError } from "@hookform/resolvers";
import * as hookForm from "react-hook-form";
import * as sup from "superstruct";

export function superstructResolver<T extends Record<string, unknown>>(
  struct: sup.Describe<T>
): hookForm.Resolver<T> {
  return (values, _, options) => {
    const [validationErrors, validValues = {}] = sup.validate(values, struct, {
      coerce: true,
      mask: true,
    });

    return {
      values: validValues,
      errors: validationErrors
        ? toNestError(parseStructErrors(validationErrors), options.fields)
        : {},
    };
  };
}

function parseStructErrors(error: sup.StructError) {
  return error.failures().reduce<Record<string, hookForm.FieldError>>(
    (acc, { message, type, refinement, path }) => ({
      ...acc,
      [path.join(".")]: {
        message,
        type: refinement ? `${type}.${refinement}` : type,
      },
    }),
    {}
  );
}
